// space
export const GUTTER = {
  small: "0.5rem",
  medium: "1rem",
  large: "2rem",
};

// shadow
export const SHADOW = "0 5px 10px rgba(0, 0, 0, 0.5)";

// colors
export const SANGRIA_LIGHT = "#d90059";
export const SANGRIA = "#560424";

// date
export const START_DATE = "March 28, 2022, 14:53:00";
